angular.module('zc.projects')

.directive 'campaignTemplateStep', (InterestWidget, Campaign, $filter) ->
  restrict: 'E'
  scope:
    campaign: '='
    templates: '='
    templateForm: '='
    pageTypes: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_template_step.html'
  link: (scope, element, attrs) ->
    InterestWidget.updateCampaignWithInterestWidget scope.campaign
    scope.Campaign = Campaign
    scope.choosingTemplate = true
    if scope.campaign.template_type
      template = _.find scope.templates,
        name: scope.campaign.template_type
      if template
        scope.campaign.campaign_type = template.campaign_type
        scope.campaign.template = template
        scope.choosingTemplate = false

    scope.hasOptionType = (option_category) ->
      return undefined unless scope.campaign.template
      for element in scope.campaign.template.template
        if element.option_category is option_category
          return true


    scope.chooseTemplate = (template) ->
      scope.choosingTemplate = false

      # do nothing if same was chosen
      return if scope.campaign.template_type is template.name

      scope.campaign.campaign_type = template.campaign_type
      scope.campaign.template_type = template.name
      scope.campaign.template = template

      InterestWidget.updateCampaignWithInterestWidget scope.campaign

      if !scope.campaign.template_type
        scope.setDefault()
      else
        scope.mergeElement()

    # Merge elements when template is chosen
    scope.mergeElement = ->

      # Message which already set
      originalElement = scope.campaign.element.message

      temp =
        message: {}

      for element in scope.campaign.template.template
        if element.name of originalElement # if message parameter is exist
          temp.message[element.name] = originalElement[element.name]
        else if "default" of element
          if typeof element.default is 'string'
            temp.message[element.name] = $filter('translate')(element.default)
          else
            temp.message[element.name] = element.default
        else
          temp.message[element.name] = ""

      # Set integrated message
      scope.campaign.element = temp

    scope.setDefault = ->
      # reset custom css
      scope.campaign.custom_css = ''

      # reset elements and reset to default values
      scope.campaign.element =
        message: {}

      for element in scope.campaign.template.template
        if "default" of element
          if typeof element.default is 'string'
            scope.campaign.element.message[element.name] = $filter('translate')(element.default)
          else
            scope.campaign.element.message[element.name] = element.default
        else
          scope.campaign.element.message[element.name] = ""

    scope.hideModalTemplateConfigItem = (item) ->
      return false unless scope.campaign.template_type in ['bannar_and_link_pc', 'bannar_and_link_sp']
      return false unless item.option_category == 'view1'
      switch scope.campaign.element.message['btn_click_action_offer']
        when 'close_modal'
          if item.name in [
            'coupon_code_copied_text_offer',
            'linkage_url_offer',
            'exclude_url_offer',
            'remove_target_blank',
            'banner_click_action'
          ]
            return true
          else
            return false
        when 'open_link'
          if item.name == 'coupon_code_copied_text_offer'
            return true
          else
            return false
        when 'copy_coupon_code'
          if item.name in [
            'linkage_url_offer',
            'exclude_url_offer',
            'remove_target_blank',
          ]
            return true
          else
            return false
        else
          return false

    scope.hideCodeIncentiveConfigItem = (item) ->
      return false unless /^timesale_ver5/.test(scope.campaign.template_type)
      incentive = scope.campaign.incentives[0]
      return false unless incentive
      return false unless incentive.incentive_type in ['coupon_url', 'api_url']
      if item.name in ['code_name', 'code_copy', 'enable_coupon_clipboard', 'code_condition']
        return true
      if incentive.incentive_type is 'api_url' and item.name in ['linkage_url', 'remove_target_blank_present']
        return true
      return false

    scope.showCouponBaseUrlHint = (item) ->
      incentive = scope.campaign.incentives[0]
      return false unless incentive
      return false unless incentive.incentive_type in ['coupon_url', 'botbonnie_short_url']
      if item.name in ['linkage_url', 'linkage_url_offer']
        return true
      return false

    scope.hideTimerConfigItem = (item) ->
      if item.name is 'enables_banner_timer' and not scope.campaign.element.message.enables_timer
        return true
      false



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_template_step.coffee